<template>
  <div class="index-wrapper">
    <div class="index-body">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="banner slide01 flex-h-cc">
            <img src="/static/images/logo.png" class="logo" />
            <div class="text-btn">
              <div class="icon-text flex-h-cc">
                <img src="/static/images/text.png" class="icon" />
              </div>
              <div class="icon-btn flex-h-cc">
                <a href="http://pay.kaka-tech.com/kakaManage/a/login"
                  ><img src="/static/images/mobile-btn.png" class="l-btn"
                /></a>
                <a href="https://www.kaka-tech.com/Kaka/Admin/Login/Login"
                  ><img src="/static/images/network-btn.png" class="r-btn"
                /></a>
              </div>
            </div>
            <div class="slide01-footer flex-h-sc">
              <div class="flex-h-sc">
                <div class="code-wrapper flex-h-cc">
                  <img src="/static/images/code.jpg" class="code" />
                </div>
                <div class="text-wrapper flex-v-cs">
                  <p class="text linkus">联系我们：0755-23617797</p>
                  <p class="text mail">招聘邮箱：oneway.chen@kaka-tech.com</p>
                  <p class="text address">
                    总部地址：深圳市南山区粤海街道科技园社区高新中二道5号生产力大楼A-513
                  </p>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide
          ><div class="banner slide02">
            <img src="/static/images/logo.png" class="logo" /></div
        ></swiper-slide>
        <swiper-slide
          ><div class="banner slide03">
            <img src="/static/images/logo.png" class="logo" /></div
        ></swiper-slide>
        <swiper-slide
          ><div class="banner slide04">
            <img src="/static/images/logo.png" class="logo" /></div
        ></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="index-footer flex-h-cc">
      <span class="text">咔咖信息科技版权所有</span>
      <a class="beian" href="https://beian.miit.gov.cn"
        >备案号：粤ICP备17024815号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      swiperOption: {
        loop: true,
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>

<style scoped>
.index-wrapper {
  width: 100%;
  height: 100%;
}
.index-body {
  width: 100%;
  height: calc(100% - 40px);
}
.index-body >>> .swiper-container {
  width: 100%;
  height: 100%;
}
.index-body >>> .swiper-slide {
  width: 100%;
  height: 100%;
}
.index-body >>> .swiper-pagination-bullet {
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
}
.index-body >>> .swiper-pagination-bullet-active {
  opacity: 1;
  background: #fff;
}
.banner {
  position: relative;
  width: 100%;
  height: 100%;
}
.banner .logo {
  position: absolute;
  left: 196px;
  top: 21px;
  width: 150px;
}
.text-btn {
  margin-bottom: 100px;
}
.icon-text {
  margin-bottom: 95px;
}
.icon-text .icon {
  height: 99px;
}
.icon-btn .l-btn,
.icon-btn .r-btn {
  width: 260px;
  cursor: pointer;
}
.icon-btn .r-btn {
  margin-left: 126px;
}
.slide01-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 160px;
  padding: 0 200px 0 196px;
  box-sizing: border-box;
}
.code-wrapper {
  width: 112px;
  height: 112px;
  margin-right: 32px;
}
.code-wrapper .code {
  width: 100%;
  height: 100%;
}
.text-wrapper .text {
  font-size: 18px;
  color: #fff;
  line-height: 1.8;
}
.banner.slide01 {
  background: url("/static/images/swiper01.jpg") center no-repeat;
  background-size: cover;
}
.banner.slide02 {
  background: url("/static/images/swiper02.jpg") center no-repeat;
  background-size: cover;
}
.banner.slide03 {
  background: url("/static/images/swiper03.jpg") center no-repeat;
  background-size: cover;
}
.banner.slide04 {
  background: url("/static/images/swiper04.jpg") center no-repeat;
  background-size: cover;
}
.index-footer {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
}
.index-footer .text {
  font-size: 12px;
  color: #666;
  line-height: 1.8;
  margin-right: 10px;
}
.index-footer .beian {
  font-size: 12px;
  color: #666;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue